import React, { useState } from 'react';
import { Form, Row, Container, Col, Button } from 'react-bootstrap';
import Snackbar from '@mui/material/Snackbar';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

import { useNavigate } from 'react-router-dom';

import './Login.css'

export const Register = () => {
  const [username, setUsername] = useState();
  const [password, setPassword] = useState();
  const [email, setEmail] = useState();
  const [name, setName] = useState();
  const [description, setDescription] = useState();
  const [NPM, setNPM] = useState();
  const [faculty, setFaculty] = useState();
  const [classOf, setClassOf] = useState();
  const [linkedin, setLinkedin] = useState();
  const [twitter, setTwitter] = useState();
  const [instagram, setInstagram] = useState();
  const [tiktok, setTiktok] = useState();
  const [loading, setLoading] = useState();
  const [isDisabled, setIsDisabled] = useState(false);
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading('Loading...');
    handleDisable();

    const url = 'https://circleui-api.herokuapp.com/api/v1/register'
    const data = {
      'username': username,
      'password': password,
      'name': name,
      'email': email,
      'description': description,
      'uiIdentityNumber': NPM,
      'faculty': faculty,
      'classOf': classOf,
      'linkedin': "-",
      'twitter': "-",
      'instagram': "-",
      'tiktok': "-"
    }
    const options = {
      method: 'POST',
      headers: {
        'accept': 'application/json',
        'content-type': 'application/json'
      },
      body: JSON.stringify(data),
    };
    await fetch(url, options)
      .then(response => response.json())
      .then(data => {
        if (data.status === 'accepted') {
          setLoading(`${data.status}: ${data.acknowledged}`);
          navigate('../login', { replace: true });
        } else if (data.status === 'rejected') {
          setLoading(`${data.status}: ${data.message}`)
        }
        handleUndisabled()
        console.log(`${data.status}: ${data.message}`)
      })
      .catch(e => console.error(e));
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  const handleDisable = () => {
    setOpen(true);
    setTimeout(() => setIsDisabled(true), 300);
  }

  const handleUndisabled = () => {
    setOpen(true);
    setTimeout(() => setIsDisabled(false), 2000);
  }

  return (
    <div className='register-container'>
      <Container>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
          message={loading}
          action={action}
        />
        <Row>
          <Col>
            <div className='register'>
              <h1 className='title-register'>Circle UI Registration Account</h1>
              <Form onSubmit={handleSubmit} className='form-register'>
                <Form.Group className="form-inline">
                  <Row className="row-register">
                    <Col xs="4" className="form-label">
                      <Form.Label>
                        <span>Username</span><span id="red-asterisk">*</span>
                      </Form.Label>
                    </Col>
                    <Col>
                      <Form.Control type="text"
                        data-testid='username'
                        name='username'
                        placeholder='username'
                        autoComplete='off'
                        onChange={e => setUsername(e.target.value)}
                        required>
                      </Form.Control>
                    </Col>
                  </Row>
                  <Row className="row-register">
                    <Col xs="4" className="form-label">
                      <Form.Label>
                        <span>Password</span><span id="red-asterisk">*</span>
                      </Form.Label>
                    </Col>
                    <Col>
                      <Form.Control type="password"
                        data-testid="password"
                        name="password"
                        placeholder='password'
                        onChange={e => setPassword(e.target.value)}
                        required>
                      </Form.Control>
                    </Col>
                  </Row>
                  <Row className="row-register">
                    <Col xs="4" className="form-label">
                      <Form.Label>
                        <span>Email</span><span id="red-asterisk">*</span>
                      </Form.Label>
                    </Col>
                    <Col>
                      <Form.Control type="email"
                        data-testid="email"
                        name="email"
                        placeholder='email'
                        autoComplete='off'
                        onChange={e => setEmail(e.target.value)}
                        required>
                      </Form.Control>
                    </Col>
                  </Row>
                  <Row className="row-register">
                    <Col xs="4" className="form-label">
                      <Form.Label>
                        <span>Name</span><span id="red-asterisk">*</span>
                      </Form.Label>
                    </Col>
                    <Col>
                      <Form.Control type="text"
                        data-testid="name"
                        name="name"
                        placeholder="name"
                        autoComplete='off'
                        onChange={e => setName(e.target.value)}
                        required>
                      </Form.Control>
                    </Col>
                  </Row>
                  <Row className="row-register">
                    <Col xs="4" className="form-label">
                      <Form.Label>
                        <span>Bio</span>
                      </Form.Label>
                    </Col>
                    <Col>
                      <Form.Control type="text"
                        data-testid="bio"
                        name="bio"
                        placeholder="bio"
                        autoComplete='off'
                        onChange={e => setDescription(e.target.value)}>
                      </Form.Control>
                    </Col>
                  </Row>
                  <Row className="row-register">
                    <Col xs="4" className="form-label">
                      <Form.Label>
                        <span>NPM</span><span id="red-asterisk">*</span>
                      </Form.Label>
                    </Col>
                    <Col>
                      <Form.Control type="text"
                        data-testid="NPM"
                        name="NPM"
                        placeholder="NPM"
                        autoComplete='off'
                        onChange={e => setNPM(e.target.value)}
                        required>
                      </Form.Control>
                    </Col>
                  </Row>
                  <Row className="row-register">
                    <Col xs="4" className="form-label">
                      <Form.Label>
                        <span>Faculty</span><span id="red-asterisk">*</span>
                      </Form.Label>
                    </Col>
                    <Col>
                      <Form.Control type="text"
                        data-testid="faculty"
                        name="faculty"
                        placeholder="faculty"
                        autoComplete='off'
                        onChange={e => setFaculty(e.target.value)}
                        required>
                      </Form.Control>
                    </Col>
                  </Row>
                  <Row className="row-register">
                    <Col xs="4" className="form-label">
                      <Form.Label>
                        <span>Class of</span><span id="red-asterisk">*</span>
                      </Form.Label>
                    </Col>
                    <Col>
                      <Form.Control type="text"
                        data-testid="classOf"
                        name="classOf"
                        placeholder="classOf"
                        autoComplete='off'
                        onChange={e => setClassOf(e.target.value)}
                        required>
                      </Form.Control>
                    </Col>
                  </Row>
                </Form.Group>
                <Button disabled={isDisabled} 
                  type="submit" 
                  variant="warning"
                  data-testid='login__button' 
                  id='register_button'>
                  Register
                </Button>
              </Form>
            </div>
          </Col>
        </Row>
        <p>Already have an account? <a href='/login'>Login</a></p>
      </Container>
    </div>
  )
}
